import React from "react";
import { MobileMenuProps } from "../types/header";
import { NavMenu } from "./NavMenu";

export const MobileMenu: React.FunctionComponent<MobileMenuProps> = (props) => {
  return <NavMenu {...props} />;
};
